<template>
    <div class="full-overlay outer-center" @click.self="overlayClicked">
        <swiper
            v-if="groupBookingFetched"
            ref="swiper"
            :options="swiperOptions"
            @slideChangeTransitionEnd="onSlideChange">
            <swiper-slide v-for="(b, index) in bookings" :key="index" >
                <div class="full-page">
                    <div class="ding-modal-wrapper">
                        <div class="ding-modal-white-background"></div>
                        <div class="ding-modal-title-bar">
                            <div class="swiper-no-swiping">
                                {{$t('booking.display_id')}} {{b.display_id}}
                                <a
                                    v-if="b.display_id"
                                    :href="'/?cbid=' + b.display_id"
                                    target="_blank"
                                    class="mr-4">
                                    {{$t('general.check_customer_link')}}</a>
                            </div>
                            <span class="ding-modal-close-button" @click="$emit('close')"></span>
                        </div>
                        <div class="ding-modal-content need-webkit-scroller-fix swiper-no-swiping">
                            <booking-content
                                :key="b.id"
                                ref="bookings"
                                :context="context"
                                :booking="b"
                                @close="$emit('close')"
                                @update-note="updateNote"
                                @update-note-to-customer="updateNoteToCustomer"
                                @request-create-following-booking="(booking) => { createFollowingBooking(booking)} "
                                :can-add-following-booking="groupBookingFetched"
                                @contract-updated="(booking, contract) => onContractUpdated(booking, contract)"
                                @customer-updated="(customer) => onCustomerUpdated(b, customer)"
                                @cancel-editing="onCancelEditing"
                            ></booking-content>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div
            v-if="groupBookingFetched && canGoNext"
            class="swiper-button swiper-button-next"
            @click="goNext"></div>
        <div
            v-if="groupBookingFetched && canGoPrev"
            class="swiper-button swiper-button-prev"
            @click="goPrev"></div>

        <loading-indicator v-if="!groupBookingFetched" :is-loading="true" :full-screen="true"></loading-indicator>
    </div>
</template>

<script>
import Vue from 'vue';
import api from '../../mixins/api';
import displayBooking from '../../mixins/display-booking';
import loadingIndicator from '../../components/common/LoadingIndicator';
import { mapActions } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
    components: {loadingIndicator, Swiper, SwiperSlide},
    mixins: [api, displayBooking],
    props: {
        initBooking: { required: true, type: Object},
        context: {
            required: true,
            type: Object
        },
    },
    mounted() {
        this.prepareBookingsIfInGroup();
        $('body, .page-content').removeClass('need-webkit-scroller-fix');

        this.context.bus.$on('payment-updated', this.paymentUpdated);
        this.context.bus.$on('payment-deleted', this.paymentDeleted);
        this.context.bus.$on('payment-created', this.paymentCreated);
        this.context.bus.$on('booking-contract-updated', this.contractUpdated);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateSwiperControlsStyleDelay);
        $('body, .page-content').addClass('need-webkit-scroller-fix');

        this.context.bus.$off('payment-updated', this.paymentUpdated);
        this.context.bus.$off('payment-deleted', this.paymentDeleted);
        this.context.bus.$off('payment-created', this.paymentCreated);
        this.context.bus.$off('booking-contract-updated', this.contractUpdated);
    },
    data() {
        return {
            swiperOptions: {
                on: {
                    click: (swiper, e) => {
                        if (e.target && $(e.target).hasClass('full-page')) {
                            this.$emit('close');
                        }
                    }
                }
            },
            bookings: [this.initBooking],
            groupBookingFetched: false,
            currentIndex: 0,
        }
    },
    computed: {
        canGoNext() {
            return this.currentIndex < this.bookings.length - 1;
        },
        canGoPrev() {
            return this.currentIndex > 0;
        },
    },
    methods: {
        ...mapActions({
            setBookingInStore: 'bookings/setBooking'
        }),
        onSlideChange() {
            this.currentIndex = this.$refs['swiper'].swiperInstance.activeIndex;
        },
        goPrev() {
            this.$refs['swiper'].swiperInstance.slidePrev(300);
        },
        goNext() {
            this.$refs['swiper'].swiperInstance.slideNext(300);
        },
        updateNote(booking, note) {
            this.$emit('update-note', booking, note);
            this.$set(booking, 'note', note);
        },
        updateNoteToCustomer(booking, note) {
            this.$emit('update-note-to-customer', booking, note);
            this.$set(booking, 'note_to_customer', note);
        },
        createFollowingBooking(booking) {
            let newBooking = {
                status: 'approved',
                service_id: null,
                service: null,
                member_user_id: null,
                member_user: null,
                start_datetime: null,
                end_datetime: null,
                customer: {
                    name: booking.customer.name,
                    phone_number: booking.customer.phone_number,
                    phone_calling_code: booking.customer.phone_calling_code,
                    email: booking.customer.email,
                    id: booking.customer.id
                },
                payments: [],
                answers: [],
                display_datetime: null,
                display_duration: null,
                display_created_at: null,
                note: null,
                parent_booking_id: booking.id,
                root_booking_id: booking.root_booking_id || booking.id
            };
            this.bookings.push(newBooking);
            this.$nextTick(() => {
                this.slideTo(this.bookings.length - 1);
                this.$refs['bookings'][this.bookings.length - 1].startEditing();
            });
        },
        onCancelEditing(booking) {
            if (!booking.id) {
                this.slideTo(this.currentIndex - 1);
                this.bookings = this.bookings.filter(b => b.id);
                if (this.bookings.length === 0) {
                    this.close();
                }
            }
        },
        prepareBookingsIfInGroup() {
            if (!this.initBooking.in_booking_group) {
                this.groupBookingFetched = true;
                return;
            }

            this.getBookingGroup(this.initBooking.id, (response, error) => {
                this.bookings = response.data;
                this.processBookings(this.context.provider, this.bookings);
                this.groupBookingFetched = true;

                let slideIndexToFocus = this.bookings.findIndex((b) => {
                    return b.id === this.initBooking.id;
                });
                this.$nextTick(() => {
                    this.slideTo(slideIndexToFocus);
                });
            });
        },
        slideTo(index) {
            this.$refs.swiper.$swiper.slideTo(index);
        },
        startEditing() {
            this.$refs['bookings'][this.$refs.swiper.$swiper.activeIndex].startEditing();
        },
        overlayClicked(e) {
            this.$emit('close');
        },
        close() {
            this.$emit('close');
        },
        onCustomerUpdated(booking, customer) {
            booking.customer = customer;
            this.$emit('customer-updated', {booking, customer});
        },
        onContractUpdated(booking, contract) {
            this.$emit('contract-updated', {booking, contract});
        },
        paymentUpdated(payment) {
            var booking = this.bookings.find((b) => b.id == payment.booking_id);
            if (!booking) {
                return;
            }
            const index = booking.payments.findIndex((p) => p.id === payment.id);
            booking.payments.splice(index, 1, payment);
            this.setBookingInStore(booking);
        },
        paymentDeleted(payment) {
            var booking = this.bookings.find((b) => b.id == payment.booking_id);
            if (!booking) {
                return;
            }
            booking.payments = booking.payments.filter((p) => p.id !== payment.id);
            this.setBookingInStore(booking);
        },
        paymentCreated(payment) {
            var booking = this.bookings.find((b) => b.id == payment.booking_id);
            if (!booking) {
                return;
            }
            if (booking.payments.findIndex((p) => p.id === payment.id) >= 0) {
                return;
            }
            booking.payments = booking.payments.map((p) => ({...p}));
            booking.payments.push(payment);
            this.setBookingInStore(booking);
        },
        contractUpdated(booking, contract) {
            var booking = this.bookings.find((b) => b.id == booking.id);
            if (!booking) {
                return;
            }
            Vue.set(booking, 'contract', {...contract});
            this.setBookingInStore(booking);
        },
    }

}
</script>

<style lang="scss" scoped>

.ding-modal-wrapper {
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    height: fit-content;
    width: calc(100vw - 80px);
    max-width: 960px;

    @media screen and (max-width: 420px) {
        width: calc(100vw - 16px);
    }
}

.ding-modal-content {
    max-height: calc(70vh - 64px);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}

.ding-modal-title-bar {
    display: flex;
    flex-direction: row;
    background: #E8E8E8;
    color: #90A4AE;
    font-size: 14px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
}

.ding-modal-title-bar > * {
    flex-grow: 1;
    font-size: 14px;
    padding: 10px 15px 10px 25px;
    margin-right: -10px;
}

.ding-modal-white-background {
    background: white;
    overflow: hidden;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.ding-modal-close-button {
    flex-grow: 0;
    display: inline-block;
    width: 30px;
    height: 30px;
    background-image: url('/img/close_cross@2x.png');
    background-size: 12px 12px;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    top: 4px;
    right: 10px;
    border-radius: 4px;
    cursor: pointer;
}

.ding-modal-close-button:hover {
    background-color: rgba(255, 255, 255, 0.2);
}

.ding-modal-footer-bar {
    background: white;
    border-top: 1px solid #EEE;
    box-shadow: 0px 4px 8px #DDD;
}


    .full-overlay {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 2147483647;
    }

    .outer-center {
        display: flex;
        flex-direction: row;
        overflow: auto;
    }

    .full-page {
        width: 100%;
        height: 100vh;
        flex-shrink: 0;
        flex-grow: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .swiper-button {
        color: #444;
        background: #E0e0e088;
        width: 40px;
        border-radius: 20px;
        height: 40px;

        &:hover {
            background: #E0e0e0bb;
        }

        &:active, &:focus {
            outline: none;
        }

        &::before, &::after {
            font-size: 20px !important;
        }
    }

    .swiper-button-disabled {
        display: none !important;
    }

    .swiper-container {
        width: 100%;
    }
</style>
